<template>
  <div>
    <!-- Anti-forgery -->
    <h3>Anti-forgery</h3>
    <div class="py-5">
      防偽措施內容，可自行添加欄位數量，以一個標題搭配一個段落內容為單位新增。
    </div>

    <div>
      <!-- support.anti_forgery -->
      <PageCollapse v-for="(item, i) in support.anti_forgery" :key="i">
        <template v-slot:head>
          <h3 class="mr-auto">Anti-forgery {{ i + 1 }}</h3>
        </template>
        <template v-slot:actions>
          <div class="ml-auto">
            <button class="btn square mr-10px" @click="deleteItem(item)">
              <v-icon class="ink-02-medium--text">delete</v-icon>
            </button>
            <button class="btn square mr-10px" @click="downItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
            </button>
            <button class="btn square" @click="upItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
            </button>
          </div>
        </template>
        <template v-slot:body>
          <!-- Basic section -->
          <div>
            <!-- Title -->
            <label class="form-item d-flex py-5">
              <div class="w-174px mr-6">
                <h4>Title</h4>
              </div>
              <div class="flex-grow-1 flex-basis-0 my-n2">
                <div class="form-input-group">
                  <v-textarea
                    v-model="item.title"
                    outlined
                    dense
                  ></v-textarea>
                </div>
              </div>
            </label>
            <!-- Content -->
            <div class="form-item d-flex py-5">
              <div class="w-174px mr-6">
                <h4>Content</h4>
              </div>
              <div class="flex-grow-1 flex-basis-0 my-n2">
                <editor
                  :key="item.id"
                  v-model="item.content"
                  :plugins="'link'"
                  :toolbar="'link'"
                  :height="100"
                />
              </div>
            </div>
            <!-- Image -->
            <div class="d-flex form-item py-5">
              <div class="w-174px mr-6">
                <h4>Image</h4>
                <div class="h5 ink-02-medium--text">
                  建議尺寸：999px * 999px <br />
                  檔案大小限制：&lt; 1 MB
                </div>
              </div>
              <div class="flex-grow-1 flex-basis-0 d-flex justify-end">
                <ImgUploader
                  :imageUrl.sync="item.image"
                  :dir="'support'"></ImgUploader>
              </div>
            </div>
          </div>
        </template>
      </PageCollapse>
      <!-- add item -->
      <div class="mt-5">
        <button class="btn btn-outlined w-100 justify-start" @click="addItem">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加一組Title+Content+Image</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PageCollapse from '@/components/PageCollapse.vue';
import Editor from '@/components/TinymceEditor.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    support: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Editor,
    PageCollapse,
    ImgUploader,
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        title: '',
        content: '',
        image: null,
      };
      this.support.anti_forgery.push(template);
    },
    deleteItem(item) {
      const index = this.support.anti_forgery.map((option) => option.id).indexOf(item.id);
      this.support.anti_forgery.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.support.anti_forgery.length - 1) {
        this.support.anti_forgery.splice(i, 1);
        this.support.anti_forgery.unshift(item);
        return;
      }
      // item become next index
      this.support.anti_forgery.splice(i, 1);
      this.support.anti_forgery.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.support.anti_forgery.splice(i, 1);
        this.support.anti_forgery.push(item);
        return;
      }
      // item become previous index
      this.support.anti_forgery.splice(i, 1);
      this.support.anti_forgery.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
